import { KpiWindowType } from '@shared/enums/kpi-window-type';
import { ITooltipRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const KpiWindowTypeListConst: ITooltipRadioButtonOption<KpiWindowType>[] = [
  {
    value: KpiWindowType.Days30,
    label: '1 month',
    tooltip: 'Completed turns in past month',
  },
  {
    value: KpiWindowType.Days60,
    label: '2 month',
    tooltip: 'Completed turns in past 2 months',
  },
  {
    value: KpiWindowType.Days90,
    label: '3 months',
    tooltip: 'Completed turns in past 3 months',
  },
  {
    value: KpiWindowType.Months6,
    label: '6 months',
    tooltip: 'Completed turns in past 6 months',
  },
  {
    value: KpiWindowType.Months12,
    label: '1 year',
    tooltip: 'Completed turns in past year',
  },
];
